module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/security/users/user/user.component.scss
// module id = ./src/app/components/security/users/user/user.component.scss
// module chunks = main